// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--bc08b";
export var image = "index-module--image--74add";
export var link = "index-module--link--e834f";
export var title = "index-module--title--7d460";
export var titleWrapper = "index-module--titleWrapper--a9926";